import { Text, VStack } from '@chakra-ui/react';
import { Container } from '@/components/layouts/Container/Container';
import { Header } from '@/components/layouts/Header/Header';
import { SubHeader } from '@/components/layouts/SubHeader/SubHeader';
import { Wrapper } from '@/components/layouts/Wrapper/Wrapper';
import { Title } from '@/components/metas/Title/Title';

const PrivacyPolicyPage = () => {
  return (
    <Wrapper header={<Header title='個人情報保護方針' />}>
      <Title title='個人情報保護方針' />
      <Container>
        <SubHeader backTo='/' />
        <VStack spacing={6} my={6}>
          <Text fontWeight='bold' fontSize='lg'>
            個人情報保護方針
          </Text>
          <VStack spacing={4} alignItems='stretch'>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>はじめに</Text>
              株式会社IMPRINT（以下「当社」といいます）は、当社が運営するトレーニング情報管理共有サービス「トレーニングシェア」において提供するサービス（情報提供、コンテンツ提供、トレーニング情報管理システム、オンラインレッスン、イベント、お問い合わせ等）の円滑な運営に必要な範囲で、トレーニングシェアを利用されるお客様の個人情報をお預かりしております。当社は個人情報を保護し、お客様に更なる信頼性と安心感をご提供できるように努めて参ります。
              <br />
              当社は、個人情報に関する法令を遵守し、個人情報の適切な取り扱いを実現致します。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>1. 個人情報の取得について</Text>
              当社は、偽りその他不正の手段によらず適正に個人情報を取得致します。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>2. 個人情報の利用について</Text>
              当社は、個人情報を以下の利用目的の達成に必要な範囲内で、利用致します。
              <br />
              以下に定めのない目的で個人情報を利用する場合、あらかじめご本人の同意を得た上で行います。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>個人情報の利用目的</Text>
              （1）当社が運営し、管理する「トレーニングシェア」の会員登録手続きのため
              <br />
              （2）「トレーニングシェア」で共有するプロフィール、トレーニング情報等掲載のため
              <br />
              （3）「トレーニングシェア」で提供する情報、サービスに関するお問合わせにお応えするため
              <br />
              （4）「トレーニングシェア」で企画・運営するイベントやオンラインレッスン等のお申し込み手続きのため
              <br />
              （5）「トレーニングシェア」で提供する情報やコンテンツの購入手続きのため
              <br />
              （6）「トレーニングシェア」で提供するトレーニング情報管理システム利用手続きのため
              <br />
              （7）「トレーニングシェア」のサービス関するご案内、コンテンツ、イベント、オンラインレッスン、セミナー等に関するメールマガジンやダイレクトメールをお送りするため
              <br />
              （8）「トレーニングシェア」のサービスに関するアンケートをお送りするため
              <br />
              （9）クレジットカード決済手続きのため
              <br />
              （10）お問合せ時のご本人確認ならびに内容確認のため
              <br />
              （11）イベント、オンラインレッスン等開催時のご本人確認のため
              <br />
              （12）その他お客様に事前に通知または公表した目的のため
              <br />
              上記以外の目的で個人情報を収集して利用する際には、その利用目的とお問合せ先を明示します。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>3. 個人情報の安全管理について</Text>
              当社は、取り扱う個人情報の漏洩、滅失または毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>4. 個人情報の委託について</Text>
              当社は、個人情報の取り扱いの全部または一部を第三者に委託する場合は、当該第三者について厳正な調査を行い、取り扱いを委託された個人情報の安全管理が図られるよう当該第三者に対する必要かつ適切な監督を行います。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>5. 個人情報の第三者提供について</Text>
              当社は、個人情報保護法等の法令に定めのある場合を除き、個人情報をあらかじめご本人の同意を得ることなく、第三者に提供致しません。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>6. 個人情報の開示・訂正等について</Text>
              当社は、ご本人から自己の個人情報についての開示の請求がある場合、速やかに開示を致します。
              <br />
              その際、ご本人であることが確認できない場合には、開示に応じません。
              <br />
              個人情報の内容に誤りがあり、ご本人から訂正・追加・削除の請求がある場合、調査の上、速やかにこれらの請求に対応致します。
              <br />
              その際、ご本人であることが確認できない場合には、これらの請求に応じません。
              <br />
              当社の個人情報の取り扱いにつきまして、上記の請求・お問い合わせ等ございましたら、下記までご連絡くださいますようお願い申し上げます。
            </Text>
            <Text fontSize='sm'>
              連絡先
              <br />
              株式会社IMPRINT
              <br />
              E-mail：info@imprint.jp
              <br />
              電話：03-6452-5858　FAX：03-6452-5859
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>
                7. 本方針の変更 本方針の内容は変更されることがあります。
              </Text>
              変更後の本方針については、当社が別途定める場合を除いて、当サイトに掲載した時から効力を生じるものとします。
            </Text>
            <Text fontSize='sm'>
              制定日：2021年7月1日
              <br />
              株式会社IMPRINT
              <br />
              代表取締役　北島康介
            </Text>
          </VStack>
        </VStack>
      </Container>
    </Wrapper>
  );
};

export default PrivacyPolicyPage;
